<template>
    <EChart
        card
        class="mt-3"
        :options="chartOptions"
        :header="$t('priceSchedule')"
        :error="requestChart.getError()"
        :loading="requestChart.getLoading()"
        type="time"
    >
        <template #nav>
            <Multiselect
                :value="pluginCampaigns"
                :placeholder="$t('campaigns')"
                :selected-options-label="$t('selectedCampaigns')"
                :disabled="requestChart.getLoading()"
                :options="pluginCampaignsOptions"
                :multiple="false"
                :allow-empty="false"
                class="width-min-250"
                @inputTrackBy="pluginCampaigns = $event"
                @change="loadData()"
            />
        </template>
    </EChart>
</template>



<script>
    import EChart from '@/components/common/EChart.vue';
    import Multiselect from '@/components/common/Multiselect.vue';

    export default {
        name: 'PriceChart',
        components: {
            EChart,
            Multiselect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChart: this.parentComponent.requestPriceChart,
                pluginCampaigns: 'in',
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                return {
                    urlParams: {
                        id: this.item.id,
                    },
                    requestParams: {
                        startDate: this.timeRange?.startDate,
                        endDate: this.timeRange?.endDate,
                        pluginCampaigns: this.pluginCampaigns,
                    },
                };
            },
            chartData() {
                return this.requestChart.getData() || [];
            },
            chartOptions() {
                const chartData = this.requestChart.getData();
                if (!chartData) {
                    return { series: [] };
                }
                const seriesNames = Object.keys(this.chartData[0]).filter(key => key !== 'date');
                const series = seriesNames.map(name => ({
                    name,
                    type: 'line',
                    step: 'end', // start'|'middle'|'end'
                    data: this.chartData.map(item => {
                        const value = item[name];
                        return [new Date(item.date).getTime(), value];
                    }),
                    areaStyle: null,
                    tooltip: {
                        valueFormatter: value => this.$format.currency(value),
                    },
                }));
                return {
                    yAxis: {
                        type: 'value',
                        name: this.$t('price'),
                        min: value => Math.floor(value.min) - 1,
                    },
                    series,
                };
            },
            pluginCampaignsOptions() {
                return [
                    { value: 'in', text: this.$t('pluginCampaignsFormOptions.in') },
                    { value: 'notIn', text: this.$t('pluginCampaignsFormOptions.notIn') },
                    { value: null, text: this.$t('pluginCampaignsFormOptions.all') },
                ];
            },
        },
        watch: {
            item: {
                immediate: true,
                handler: 'loadData',
            },
            timeRange: {
                immediate: false,
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.requestChart.reset();
                this.fetchChart();
            },
            fetchChart(params = {}) {
                this.requestChart.get(this.apiParams);
            },
        },
    };
</script>
